var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('a',{class:['link_watch', _vm.advanced.cssClasses, _vm.responsiveClasses],style:(_vm.style),attrs:{"href":_vm.basic.linkUrl ? _vm.basic.linkUrl.url : '',"id":_vm.advanced.cssId}},[_vm._v(" "+_vm._s(_vm.basic.content || 'Link')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }